/*
 * @Description:
 * @Author: Leyton
 * @LastEditors: Leyton
 * @LastEditTime: 2022-07-22 11:23:56
 * @FilePath: /91qs_answer_frontpro/src/pages/drag/SinglePageDrag.jsx
 */
import {Input, Spin} from "antd";
import {Toast} from "antd-mobile";
import {isEmpty} from "lodash";
import React, {useState, useEffect} from "react";
import {language} from "@/utils/language";
import PubSub from "pubsub-js";

function Index({n, c, f}) {
    return (
        <div
            style={{
                color: f&&!c ? "#9b9b9d" : "white",
                background: f&&!c ? "#9b9b9d" : (c ? "#3c8dff" : "white"),
                width: 24,
                height: 24,
                border: f&&!c ? "none" : (!c ? "1px solid #ccc" : "none"),
                borderRadius: "50%",
                userSelect: "none",
                display: "inline-block",
                marginRight: 6,
                textAlign: "center",
                verticalAlign: "middle",
                lineHeight: "24px",
            }}
        >
            {n}
        </div>
    );
}

function translateY({element, yPos, unit = 4}) {
    if (!(element instanceof HTMLElement)) {
        throw Error("请传入要位移的dom元素");
    }

    const offset = parseInt(element.style.transform?.substring(11)) || 0;
    if (offset === yPos) return;

    const speed = Math.abs(yPos - offset) / 200;

    let y = offset;
    element.style.zIndex = 9999;
    const interval = setInterval(() => {
        try {
            y += yPos > offset ? unit * speed : -unit * speed;
            element.style.transform = "translateY(" + y + "px)";

            if (Math.abs(Math.abs(y) - Math.abs(yPos)) <= unit) {
                element.style.transform = "translateY(" + yPos + "px)";
                element.style.zIndex = "unset";
                clearInterval(interval);
            }
        } catch (error) {
            console.log("[translateY] error", error.message);
            element.style.zIndex = "unset";
            clearInterval(interval);
        }
    }, 1);
}

function SiglePageDrag(props) {
    const {info: __info, answer, changeAnswer} = props;

    let info = {...__info, childs: __info.childs.sort((a, b) => a.orders - b.orders)};
    const [options, setOptions] = useState([]);
    const [init, setInit] = useState(false);
    const [anim, setAnim] = useState(false);
    const [loading, setLoading] = useState(true);
    const [fixedOptions, setFixedOptions] = useState([]);

    useEffect(() => {
        setTimeout(() => {
            setAnim(true);
            setLoading(false);
        }, 300);
    }, []);

    const oid2cIndex = (oid) => {
        let index = -1,
            codeValue = -1;
        info.childs.find(({options}, i) => {
            const opt = options.find((o) => o.id === oid);
            if (opt) {
                index = i;
                codeValue = opt.codeValue;
                return true;
            }
            return false;
        });

        return [index, codeValue];
    };

    useEffect(() => {
        const newOptions = info.options.filter((o) => o?.hide !== 1 && o?.hideSelected !== 1);

        const answerObj = answer[info.id] || answer;
        if (!isEmpty(answerObj) && !init) {
            for (const cid in answerObj) {
                if (Object.hasOwnProperty.call(answerObj, cid)) {
                    const obj = answerObj[cid];
                    const [oid] = Object.keys(obj);
                    const [index, codeValue] = oid2cIndex(oid);

                    newOptions.forEach((o) => {
                        // 已经排序的
                        if (o.codeValue === codeValue) {
                            o.tagIndex = index + 1;
                            o.isChecked = true;
                            o.valuePs = obj?.[oid]?.text;
                            o.text = obj?.[oid]?.text;
                        }
                    });
                }
            }
            const answerCount = Object.keys(answerObj).length;
            newOptions
                .filter((o) => !o.isChecked) // 没有排序的
                .forEach((o, i) => {
                    o.isChecked = false;
                    o.tagIndex = i + 1 + answerCount;
                    return o;
                });

            setInit(true);
            setOptions(newOptions);
        }
    }, [answer]);

    useEffect(() => {
        if (isEmpty(answer)) {
            const newOptions =
                info.options.filter((o) => o?.hide !== 1 && o?.hideSelected !== 1)
                    .filter((o) => !(o?.selected === 1 && o?.fixed === 1));
            const fixed = info.options.filter((o) => o?.selected === 1 && o?.fixed === 1);
            setFixedOptions(fixed)
            const {childs} = info;
            const ansObj = {};

            newOptions
                .forEach((o, i) => {
                    const text = o?.text
                    o.tagIndex = i + 1;
                    if (o?.selected === 1) {
                        o.isChecked = true;
                        const {id: qid, options: co} = childs[0];
                        const {id: oid} = co.find((o2) => o2.codeValue === o.codeValue);
                        ansObj[qid] = {[oid]: text ? {text} : null};
                    } else {
                        o.isChecked = false;
                    }
                    return o;
                });

            setOptions(newOptions);
            changeAnswer(ansObj);
        }
    }, []);

    // update answer
    useEffect(() => {
        if (!anim) return;

        const {childs} = info;

        const ansObj = {};
        options.forEach(({isChecked, tagIndex, codeValue, text}) => {
            if (isChecked) {
                const {id: qid, options: co} = childs[tagIndex - 1];
                const {id: oid} = co.find((o) => o.codeValue === codeValue);
                ansObj[qid] = {[oid]: text ? {text} : null};
            }
        });

        console.log("修改了答案",);
        changeAnswer(ansObj);
    }, [options]);

    // animation
    useEffect(() => {
        if (anim) {
            setTimeout(() => {
                let clientY = 0;
                for (let i = 0; i < options.length; i++) {
                    const {id, tagIndex} = options[i];
                    const element = document.getElementById(id);

                    let offsetTop = 0;
                    const prevElts = options.filter((opt) => opt.tagIndex < tagIndex);
                    for (let j = 0; j < prevElts.length; j++) {
                        const {id} = prevElts[j];
                        const element = document.getElementById(id);
                        offsetTop += element.clientHeight + 12;
                    }

                    translateY({element, yPos: offsetTop - clientY});
                    clientY += element.clientHeight + 12;
                }
            }, 0);
        } else {

            let clientY = 0;
            for (let i = 0; i < options.length; i++) {
                const {id, tagIndex} = options[i];
                const element = document.getElementById(id);

                let offsetTop = 0;
                const prevElts = options.filter((opt) => opt.tagIndex < tagIndex);

                for (let j = 0; j < prevElts.length; j++) {
                    const {id} = prevElts[j];
                    const element = document.getElementById(id);
                    offsetTop += element.clientHeight + 12;
                }

                translateY({element, yPos: offsetTop - clientY});
                clientY += element.clientHeight + 12;
            }
        }
    }, [options]);

    const handleClick = (option) => {
        // console.log(option.id, "is clicked.");
        setInit(true); // 点击修改答案不触发初始化答案的操作

        if (!option.isChecked) {
            let icl = info.childs.length;
            let ol = options.filter((o) => o.isChecked).length;

            if (icl <= ol) {
                if (sessionStorage.getItem("internationalizeFlag") == "jap") {


                    return PubSub.publish("Modalalert", `最初の${icl+fixedOptions?.length|0}つをソートしてください`);
                }
                return PubSub.publish("Modalalert", language().sort_num + (icl+fixedOptions?.length|0));
            }

            const checkedCount = options.filter((o) => o.isChecked).length;
            let newOptions = options.map((opt, i) => {
                if (opt.id === option.id) {
                    return {...option, tagIndex: checkedCount + 1, isChecked: true};
                }
                return {
                    ...opt,
                    tagIndex:
                        opt.tagIndex < option.tagIndex && !opt.isChecked
                            ? opt.tagIndex + 1
                            : opt.tagIndex,
                };
            });
            console.log(newOptions.map((o) => o.tagIndex));
            setOptions(newOptions);
        } else {
            const effectedCount = options.filter(
                (o) => o.tagIndex > option.tagIndex && o.isChecked
            ).length;
            const newOptions = options.map((o) => {
                if (o.tagIndex > option.tagIndex && o.isChecked) {
                    o.tagIndex--;
                }
                return o;
            });

            const opt = newOptions.find((o) => o.id === option.id);
            opt.tagIndex += effectedCount;
            opt.isChecked = false;

            console.log(newOptions.map((o) => o.tagIndex));
            setOptions(newOptions);
        }
    };

    const handleChange = (optionId, value) => {
        const newOptions = options.map((opt) => {
            if (opt.id === optionId) {
                return {...opt, text: value, valuePs: value};
            }
            return opt;
        });
        setOptions(newOptions);
    };
    console.log(22222, answer, options);
    return (
        <div style={{padding: 10}}>
            <Spin spinning={loading}>
                {fixedOptions.map((o, i) => (
                    <div
                        key={o.id}
                        id={o.id}
                        style={{
                            border: "1px solid #eee",
                            padding: 10,
                            marginBottom: 10,
                            backgroundColor: "#e6f2fa",
                            borderRadius: 4,
                            cursor: "not-allowed",
                            display: "grid",
                            grid: "auto / 34px auto",
                            alignItems: "center",
                            userSelect: "none",
                        }}
                    >
                        <Index n={i + 1} c={true} f={true}/>
                        <div style={{textAlign: "left"}}>
                            <div dangerouslySetInnerHTML={{__html: o.description}}></div>
                        </div>
                    </div>
                ))}
                {options.map((o, index) => (
                    <div
                        key={o.id}
                        id={o.id}
                        style={{
                            border: "1px solid #eee",
                            padding: 10,
                            marginBottom: 10,
                            backgroundColor: o?.fixed ? "#9b9b9d" : (o.isChecked ? "#e6f2fa" : "white"),
                            borderRadius: 4,
                            cursor: o?.fixed ? "not-allowed" : "pointer",
                            display: "grid",
                            grid: "auto / 34px auto",
                            alignItems: "center",
                            userSelect: "none",
                        }}
                        onClick={() => !o?.fixed && handleClick(o)}
                    >
                        <Index n={o.tagIndex + (fixedOptions?.length | 0)} c={o.isChecked} f={o?.fixed}/>
                        <div style={{textAlign: "left"}}>
                            <div dangerouslySetInnerHTML={{__html: o.description}}></div>
                            {o.open && o.isChecked ? (
                                <Input
                                    placeholder={language().input_placeholder}
                                    value={o.valuePs}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                    }}
                                    onChange={(e) => handleChange(o.id, e.target.value)}
                                />
                            ) : (
                                <></>
                            )}
                        </div>
                    </div>
                ))}
            </Spin>
        </div>
    );
}

export default SiglePageDrag;

// export default React.memo(SiglePageDrag, (props, nextProps) => {
//   if (props.info === nextProps.info) {
//     console.info("same information, not render");
//     return true;
//   }
// });
